import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@/fontawesome';
import { useDarkMode } from '@/hooks/useDarkMode';

interface DarkModeToggleProps {
  className?: string;
}

export default function DarkModeToggle({ className }: DarkModeToggleProps) {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className={`p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-200 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700 transition-colors cursor-pointer ${className ?? ''}`}
      title={isDarkMode ? 'Light Mode' : 'Dark Mode'}
      aria-label={isDarkMode ? 'Zu Light Mode wechseln' : 'Zu Dark Mode wechseln'}
    >
      <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} className="w-5 h-5" />
    </button>
  );
}
